import { useTranslation } from 'react-i18next';
import { getEventTranslation } from '../utils/eventTranslation';
import { formatDateRangeLong } from '../utils/dateUtils';

const EventContentModal = ({ setViewContentModal, viewEvent }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const eventName = getEventTranslation(viewEvent, 'name', currentLang);
  const eventSubHeader = getEventTranslation(viewEvent, 'subHeader', currentLang);
  const eventDescription = getEventTranslation(viewEvent, 'description', currentLang);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-md shadow-lg w-2/3 max-w-3xl overflow-y-auto">
        <div className="relative w-full h-64 flex items-center justify-center mb-4">
          <img
            src={viewEvent.image}
            alt={eventName}
            className="max-w-full max-h-full rounded-md object-cover"
          />
        </div>

        <div className="mt-4">
          <h2 className="text-2xl font-bold mb-2">{eventName}</h2>
          <h3 className="text-lg text-gray-600 mb-4">{eventSubHeader}</h3>
        </div>

        <div className="mt-4">
          <div className="font-semibold text-gray-700">Date:</div>
          <p className="text-lg">{formatDateRangeLong(viewEvent, currentLang)}</p>
        </div>

        <div className="mt-4">
          <div className="font-semibold text-gray-700">Time:</div>
          <p className="text-lg">{viewEvent.time}</p>
        </div>

        <div className="mt-4">
          <div className="font-semibold text-gray-700">Location:</div>
          <p className="text-lg">{viewEvent.location}</p>
        </div>

        <div className="mt-4">
          <div className="font-semibold text-gray-700">Description:</div>
          <p className="text-base mt-2 whitespace-pre-wrap">{eventDescription}</p>
        </div>

        {/* Action Links */}
        {(viewEvent.signUpLink || viewEvent.learnMoreLink) && (
          <div className="mt-6 flex gap-3">
            {viewEvent.signUpLink && (
              <a
                href={viewEvent.signUpLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-md transition-colors"
              >
                Signup
              </a>
            )}
            {viewEvent.learnMoreLink && (
              <a
                href={viewEvent.learnMoreLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-md transition-colors"
              >
                Learn More
              </a>
            )}
          </div>
        )}

        <div className="flex justify-end mt-6">
          <button
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
            onClick={() => {
              setViewContentModal(false);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export { EventContentModal };
